module.exports = __webpack_public_path__ + "assets/img/time.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/time.png
// module id = 701
// module chunks = 0